import axios from 'axios'

export default {
    download(filter) {
        return axios.download('/api/complaintcodes/export',
            {
                productId: filter.productId,
                description: filter.text,
                code: filter.text
            });
    },
    getCodes(page, productId, text) {
        return axios.get('/api/complaintcodes/table',
            {
                params: {
                    page: page,
                    productId: productId,
                    description: text,
                    code: text
                }
            });
    },
    getCode(id) {
        return axios.get(`/api/complaintcodes/${id}`);
    },
    saveCode(id, code) {
        if (id) {
            return axios.put(`/api/complaintcodes/${id}`, code);
        }
        return axios.post('/api/complaintcodes', code);
    },
    deleteCode(id) {
        return axios.delete(`/api/complaintcodes/${id}`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/masters/complaintcodes/api.js